import { GeneralStyle } from '@website-builder/model/style/general-style';

export class TitleBase extends GeneralStyle {
  size = '';
  color = 'uk-color-black';
  font = '';
  decoration = '';
  decorationColor = '';
  marginTop = 'uk-margin-remove-top';

  static normalize(styles: Partial<TitleBase>): TitleBase {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new TitleBase();

    Object.assign(pureStyles, generalStyle);

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
